import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect, useDispatch, useSelector, shallowEqual } from 'react-redux';

import { logout, logoutRequest } from 'store/user/actions';
import { getUserAccessToken } from 'store/user/selector';

import { PRIVACY_SETTINGS } from 'shared/urlList';

import styles from './ProfileMenu.module.scss';

const ProfileMenu = ({ user, location, ...props }) => {
    const dispatch = useDispatch();
    const userToken = useSelector(getUserAccessToken, shallowEqual);

    const userProfileLink = user && user.id ? `/profile/${user.id}` : '/home';

    return (
        <section className={styles.profile_menu}>
            <div className={styles.span}></div>
            <Link to={userProfileLink}>
                <div className={styles.sections}>My Profile</div>
            </Link>
            <Link
                to={{
                    pathname: PRIVACY_SETTINGS.PERSONAL_INFOS,
                    state: { prevPath: location.pathname },
                }}
            >
                <div className={styles.sections}>Profile Settings</div>
            </Link>
            {userToken ? (
                <div
                    className={styles.sections}
                    onClick={() => dispatch(logoutRequest())}
                >
                    Log out
                </div>
            ) : null}
        </section>
    );
};

const mapDispatchToProps = {
    logout: (props) => logout(props),
};

export default withRouter(connect(null, mapDispatchToProps)(ProfileMenu));
